export function KfAvatar({
  name,
  avatar,
  size = 32,
}: {
  name: string;
  avatar?: string | null;
  size?: number;
}) {
  if (avatar) {
    return (
      <img
        src={avatar}
        alt={name}
        className="rounded-full object-cover shrink-0"
        style={{ height: size, width: size }}
      />
    );
  }
  return (
    <div
      className="rounded-full bg-muted flex items-center justify-center text-muted-foreground/80 shrink-0"
      style={{ height: size, width: size, fontSize: size * 0.4 }}
    >
      {name.charAt(0).toUpperCase()}
    </div>
  );
}
